import { render, staticRenderFns } from "./FilesWidget.vue?vue&type=template&id=647531ca"
import script from "./FilesWidget.vue?vue&type=script&lang=js"
export * from "./FilesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports